<ng-content select="[slot='picture']"></ng-content>
<ng-content select="[slot='title']"></ng-content>
<ng-content select="[slot='content']"></ng-content>
